import {
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  CircularProgress,
  Box,
  Button,
} from '@mui/material';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import { useContext, useEffect, useState } from 'react';
import styled from 'styled-components';
import { GridCloseIcon } from '@mui/x-data-grid';
import VisibilityIcon from '@mui/icons-material/Visibility';
import CloseIcon from '@mui/icons-material/Close';
import axios from 'axios';
import { AuthContext } from '../../../components/contextAPI/ContextAPI';

const Container = styled.div`
  border-radius: 10px;
  background: #ffffff;
  padding: 5px 0;
`;

const FlexContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const InfoContainer = styled.div`
  width: 100%;
  text-align: start;
`;

const Block = styled.div`
  margin: 5px 0 0 0;
`;

const Span = styled.span`
  font-size: 14px;
  font-weight: 500;
  line-height: 17.71px;
`;

const OwnerName = styled.span`
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
  letter-spacing: 0%;
  color: #0088cc;
`;

const Date = styled.span`
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  letter-spacing: 0%;
`;

const Status = styled.span`
  display: 'block';
  border-radius: 15px;
  color: #fff;
  font-weight: 500;
`;

const StatusTxt = styled.span`
  color: #fff;
  font-weight: 500;
`;

const DialogContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 15px;
`;

const DistributorCard = ({ mapObj, onClick, style, showEdit, onEdit }) => {
  const { auth } = useContext(AuthContext);

  const [openDialog, setOpenDialog] = useState(false);
  const [openDialog2, setOpenDialog2] = useState(false);
  const [pdfUrl, setPdfUrl] = useState('');

  const [currentUser, setCurrentUser] = useState({});
  const [herokuData, setHerokuData] = useState({});
  const [pdfLoading, setPdfLoading] = useState(true);

  // Depend on `mapObj` so a card instance reused for a different row (the list
  // renders with stable keys, but keep this reactive regardless) refreshes the
  // current user and heroku ids instead of keeping the first-mounted record's.
  useEffect(() => {
    setCurrentUser(auth.user);
    setHerokuData({
      herokuId: mapObj?.sfid,
      herokuSfid: mapObj?.heroku_id__c ?? mapObj?.sfid,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mapObj]);

  // Full distributor name for the CURRENT record, computed every render so it
  // can never go stale. Guards a null firm name by falling back to the city
  // (then a dash) instead of rendering "null-<city>".
  const firmName = mapObj?.firm_name__c || '';
  const city = mapObj?.city__c || '';
  const distributorName = firmName
    ? mapObj?.sap_id__c
      ? `${mapObj.sap_id__c}-${firmName}${city ? `-${city}` : ''}`
      : `${firmName}${city ? `-${city}` : ''}`
    : city || '—';

  const getFormattedDate = (date) => {
    const months = {
      '01': 'Jan',
      '02': 'Feb',
      '03': 'Mar',
      '04': 'Apr',
      '05': 'May',
      '06': 'Jun',
      '07': 'Jul',
      '08': 'Aug',
      '09': 'Sep',
      10: 'Oct',
      11: 'Nov',
      12: 'Dec',
    };

    if (!date) {
      return 'N/A';
    }

    const splittedDate = date.split('-');
    const monthName = months[splittedDate[1]];

    return `${splittedDate[2]}-${monthName}-${splittedDate[0]}`;
  };

  const generatePDF = async () => {
    try {
      setOpenDialog2(true);
      setPdfLoading(true);
      let result = await window.Platform.database.generatePdf({
        herokuId: herokuData.herokuId,
        herokuSfid: herokuData.herokuSfid,
      });

      const base64String = `data:application/pdf;base64,${result?.data?.base64}`;
      setPdfUrl(base64String);
      // setOpenDialog2(true);
    } catch (error) {
      console.error(error);
    } finally {
      setPdfLoading(false);
    }
  };

  const renderContent = () => {
    return (
      <Container
        style={{ display: mapObj ? 'block' : 'none', ...style }}
        onClick={onClick}
      >
        <FlexContainer style={{ margin: '2px 10px 0 10px' }}>
          <Date>{getFormattedDate(mapObj?.createddate)}</Date>
          <Status
            style={{
              backgroundColor: mapObj.distributor_approval_status__c
                ?.toLowerCase()
                ?.includes('approved')
                ? '#00B200'
                : mapObj.distributor_approval_status__c
                  ?.toLowerCase()
                  ?.includes('sent for')
                  ? '#E57300'
                  : '#FF3333',
              width: '10px',
              height: '10px',
              borderRadius: '100%',
            }}
          ></Status>
        </FlexContainer>

        <FlexContainer style={{ margin: '10px 10px 2px 10px' }}>
          <InfoContainer>
            <Block>
              <Span>Distributor Name: </Span>
              <OwnerName title={distributorName}>{distributorName}</OwnerName>
            </Block>

            <Block>
              <Span>Mobile: </Span>
              {mapObj?.mobile__c ? (
                <OwnerName>{mapObj?.mobile__c}</OwnerName>
              ) : (
                <OwnerName>N/A</OwnerName>
              )}
            </Block>

            <Block>
              <Span>GSTIN Applied: </Span>
              {mapObj?.gstin_applied__c ? (
                <OwnerName>{mapObj?.gstin_applied__c?.toString()}</OwnerName>
              ) : (
                <OwnerName>N/A</OwnerName>
              )}
            </Block>

            <Block>
              <Span>Tehsil: </Span>
              {mapObj?.sub_district_name__c ? (
                <OwnerName>{mapObj?.sub_district_name__c}</OwnerName>
              ) : (
                <OwnerName>N/A</OwnerName>
              )}
            </Block>

            <Block>
              <Span>Status: </Span>
              {mapObj?.distributor_approval_status__c ? (
                <StatusTxt
                  style={{
                    color: mapObj.distributor_approval_status__c
                      ?.toLowerCase()
                      ?.includes('approved')
                      ? '#00B200'
                      : mapObj.distributor_approval_status__c
                        ?.toLowerCase()
                        ?.includes('sent for')
                        ? '#E57300'
                        : '#FF3333',
                    fontWeight: 700,
                  }}
                >
                  {mapObj.distributor_approval_status__c}
                </StatusTxt>
              ) : (
                <StatusTxt style={{ color: '#FF3333', fontWeight: 700 }}>
                  Need to Update
                </StatusTxt>
              )}
            </Block>

            <Block>
              <Span>View Document: </Span>
              <OwnerName>
                <IconButton
                  className='no-nav'
                  size='small'
                  color='primary'
                  disableRipple
                  onPointerDown={(e) => e.stopPropagation()}
                  onMouseDown={(e) => e.stopPropagation()}
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    generatePDF();
                  }}
                >
                  <VisibilityIcon />
                </IconButton>

                <Dialog
                  open={openDialog2}
                  onClose={() => setOpenDialog2(false)}
                  maxWidth='md'
                  fullWidth
                  style={{ zIndex: 999999 }}
                >
                  <DialogTitle>
                    Preview
                    <IconButton
                      aria-label='close'
                      onPointerDown={(e) => e.stopPropagation()}
                      onMouseDown={(e) => e.stopPropagation()}
                      onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        setOpenDialog2(false);
                      }}
                      sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                      }}
                    >
                      <CloseIcon />
                    </IconButton>
                  </DialogTitle>
                  <DialogContent dividers>

                    {pdfLoading && (
                      <Box
                        sx={{
                          position: 'absolute',
                          inset: 0,
                          bgcolor: 'background.paper',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          zIndex: 1,
                        }}
                      >
                        <CircularProgress />
                      </Box>
                    )}

                    <Box sx={{ width: '100%', height: '80vh' }}>
                      {pdfUrl ? (
                        <iframe
                          key={pdfUrl}
                          src={pdfUrl}
                          title="PDF Preview"
                          onLoad={() => setPdfLoading(false)}
                          style={{
                            width: '100%',
                            height: '100%',
                            border: 'none',
                          }}
                        />
                      ) : (
                        <Box
                          sx={{
                            width: '100%',
                            height: '100%',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            color: 'text.secondary',
                            p: 2,
                          }}
                        >
                          No PDF to preview
                        </Box>
                      )}
                    </Box>
                  </DialogContent>
                </Dialog>
              </OwnerName>
            </Block>

            {showEdit && (
              <Block>
                <Button
                  className='no-nav'
                  size='small'
                  variant='outlined'
                  color='primary'
                  startIcon={<EditOutlinedIcon />}
                  onPointerDown={(e) => e.stopPropagation()}
                  onMouseDown={(e) => e.stopPropagation()}
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    onEdit && onEdit(mapObj);
                  }}
                  style={{ marginTop: 8, textTransform: 'none' }}
                >
                  Edit
                </Button>
              </Block>
            )}
          </InfoContainer>
        </FlexContainer>
      </Container>
    );
  };

  return (
    <>
      <Container style={{ boxShadow: '0px 4px 10px 0px #0000001A' }}>
        {renderContent()}
      </Container>
    </>
  );
};

export default DistributorCard;
